import React from "react";
import { SearchResults } from "./SearchResults";
import { LoadingState, NoSearchResults } from "./components";
import { CategoryType } from "./constants";

interface CategoryDetailProps {
  selectedCategory: CategoryType | undefined;
  stockSearchData: any[];
  cryptoSearchData: any[];
  searchLoading: boolean;
  onItemClick: (item: any, category: CategoryType) => void;
}

export const CategoryDetail: React.FC<CategoryDetailProps> = ({
  selectedCategory,
  stockSearchData,
  cryptoSearchData,
  searchLoading,
  onItemClick,
}) => {
  if (!selectedCategory) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 pb-6">
      {/* 加载状态 */}
      {searchLoading && (
        <LoadingState count={8} className="grid-cols-1 gap-2" />
      )}

      {/* 所有搜索结果 */}
      {!searchLoading && (
        <SearchResults
          data={
            selectedCategory === CategoryType.STOCKS
              ? stockSearchData
              : cryptoSearchData
          }
          isLoading={false}
          onItemClick={(item) => onItemClick(item, selectedCategory)}
          hasNextPage={false}
        />
      )}

      {/* 该分类无结果 */}
      {!searchLoading &&
        ((selectedCategory === CategoryType.STOCKS &&
          stockSearchData.length === 0) ||
          (selectedCategory === CategoryType.CRYPTO &&
            cryptoSearchData.length === 0)) && <NoSearchResults />}
    </div>
  );
};
